/*This is the index registry for reducers.
 *If you wish to add a reducer you must register it here.
 *When an action is sent, it will be sent to all of these reducers
 * and only one will answer.  This is why all action Names must be unique.
 * @author Adam Kale @ Pufferfish Limited.
 */

import { combineReducers } from "redux";
import AppsReducer from "./AppsReducer.js";
import UserReducer from "./UserReducer.js";

const allReducers = combineReducers({
  AppsStates: AppsReducer,
  UserStates: UserReducer,
});

export default allReducers;
